import PropTypes from 'prop-types';
import { PickerTypes } from '../../constants';
import MediaBridgeProvider from '../internal/MediaBridgeProvider';
import AbstractPicker from './AbstractPicker';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotVideoPicker = props => {
  return /*#__PURE__*/_jsx(MediaBridgeProvider, {
    rootNode: props.rootNode,
    pickerType: PickerTypes.HUBSPOT_VIDEO,
    children: /*#__PURE__*/_jsx(AbstractPicker, Object.assign({}, props))
  });
};
HubSpotVideoPicker.propTypes = Object.assign({}, AbstractPicker.propTypes, {
  editingVideoId: PropTypes.number,
  showNonEmbeddable: PropTypes.bool
});
export default HubSpotVideoPicker;